import LogoDaee from "../../../../../../images/logo_daee_aparado.png"
import LogoSpAguas from "@images/entities_logo/sp_aguas_small.png"
import LogoAna from "../../../../../../images/logo_ana.png"
import LogoCemaden from "../../../../../../images/logo_cemaden.png"
import('../../../../../../styles/pages/charts/index/components/supporters.css')

export default function Supporters(){
    let container, images_container
    this.generate = () =>{
        container = document.createElement("div")
        $(container).addClass("supporters-container")

        generateImages()
        container.appendChild(images_container)
        $(document.body).append(container)

        setPosition()
    }

    function generateImages(){
        images_container = document.createElement('div')
        images_container.classList.add("supporters-images-container")

        // $.each([{url:LogoDaee,title:'daee'}, {url:LogoAna,title:'ana'} ,{url:LogoCemaden,title:'cemaden'}], (index, logo)=>{
            $.each([{url:LogoSpAguas,title:'spaguas'}], (index, logo)=>{
            let image = generateImage(logo)
            $(images_container).append(image.outerHTML)
        })
    }

    function generateImage(logo){
        let image = document.createElement('div')
        image.classList.add("supporter-image-container")

        let img = new Image()
        img.src = logo.url
        if(logo.title == 'spaguas'){
            $(img).css({"width": "100px"})
        }
        $(image).append(img.outerHTML)
        return image

    }

    function setPosition(){
        let HEADER_SIZE = $("#main_header").outerHeight();
        let BREADCRUMB_SIZE = $(".container-breadcrumb").outerHeight();
        let top = HEADER_SIZE + BREADCRUMB_SIZE + 70

        $(container).css({"top": top.toString() + "px", "left": "0px"})
    }
}